export const stats = {
    "1":{
      "statId":1,
      "nameKey":"UnitStat_Health",
      "descKey":"UnitStatDescription_Health_TU7",
      "isDecimal":false,
      "name":"Health",
      "detailedName":"Max Health"
    },
    "2":{
      "statId":2,
      "nameKey":"UnitStat_Strength",
      "descKey":"UnitStatDescription_Strength",
      "isDecimal":false,
      "name":"Strength",
      "detailedName":"Strength"
    },
    "3":{
      "statId":3,
      "nameKey":"UnitStat_Agility",
      "descKey":"UnitStatDescription_Agility",
      "isDecimal":false,
      "name":"Agility",
      "detailedName":"Agility"
    },
    "4":{
      "statId":4,
      "nameKey":"UnitStat_Intelligence_TU7",
      "descKey":"UnitStatDescription_Intelligence",
      "isDecimal":false,
      "name":"Tactics",
      "detailedName":"Tactics"
    },
    "5":{
      "statId":5,
      "nameKey":"UnitStat_Speed",
      "descKey":"UnitStatDescription_Speed",
      "isDecimal":false,
      "name":"Speed",
      "detailedName":"Speed"
    },
    "6":{
      "statId":6,
      "nameKey":"UnitStat_AttackDamage",
      "descKey":"UnitStatDescription_AttackDamage",
      "isDecimal":false,
      "name":"Physical Damage",
      "detailedName":"Physical Damage"
    },
    "7":{
      "statId":7,
      "nameKey":"UnitStat_AbilityPower",
      "descKey":"UnitStatDescription_AbilityPower",
      "isDecimal":false,
      "name":"Special Damage",
      "detailedName":"Special Damage"
    },
    "8":{
      "statId":8,
      "nameKey":"UnitStat_Armor",
      "descKey":"UnitStatDescription_Armor",
      "isDecimal":false,
      "name":"Armor",
      "detailedName":"Armor"
    },
    "9":{
      "statId":9,
      "nameKey":"UnitStat_Suppression",
      "descKey":"UnitStatDescription_Suppression",
      "isDecimal":false,
      "name":"Resistance",
      "detailedName":"Resistance"
    },
    "10":{
      "statId":10,
      "nameKey":"UnitStat_ArmorPenetration",
      "descKey":"UnitStatDescription_ArmorPenetration",
      "isDecimal":false,
      "name":"Armor Penetration",
      "detailedName":"Armor Penetration"
    },
    "11":{
      "statId":11,
      "nameKey":"UnitStat_SuppressionPenetration",
      "descKey":"UnitStatDescription_SuppressionPenetration",
      "isDecimal":false,
      "name":"Resistance Penetration",
      "detailedName":"Resistance Penetration"
    },
    "12":{
      "statId":12,
      "nameKey":"UnitStat_DodgeRating_TU5V",
      "descKey":"UnitStatDescription_DodgeRating",
      "isDecimal":false,
      "name":"Dodge Chance",
      "detailedName":"Dodge Rating"
    },
    "13":{
      "statId":13,
      "nameKey":"UnitStat_DeflectionRating_TU5V",
      "descKey":"UnitStatDescription_DeflectionRating",
      "isDecimal":false,
      "name":"Deflection Chance",
      "detailedName":"Deflection Rating"
    },
    "14":{
      "statId":14,
      "nameKey":"UnitStat_AttackCriticalRating_TU5V",
      "descKey":"UnitStatDescription_AttackCriticalRating",
      "isDecimal":false,
      "name":"Physical Critical Chance",
      "detailedName":"Physical Critical Rating"
    },
    "15":{
      "statId":15,
      "nameKey":"UnitStat_AbilityCriticalRating_TU5V",
      "descKey":"UnitStatDescription_AbilityCriticalRating",
      "isDecimal":false,
      "name":"Special Critical Chance",
      "detailedName":"Special Critical Rating"
    },
    "16":{
      "statId":16,
      "nameKey":"UnitStat_CriticalDamage",
      "descKey":"UnitStatDescription_CriticalDamage",
      "isDecimal":true,
      "name":"Critical Damage",
      "detailedName":"Critical Damage"
    },
    "17":{
      "statId":17,
      "nameKey":"UnitStat_Accuracy",
      "descKey":"UnitStatDescription_Accuracy",
      "isDecimal":true,
      "name":"Potency",
      "detailedName":"Potency"
    },
    "18":{
      "statId":18,
      "nameKey":"UnitStat_Resistance",
      "descKey":"UnitStatDescription_Resistance",
      "isDecimal":true,
      "name":"Tenacity",
      "detailedName":"Tenacity"
    },
    "19":{
      "statId":19,
      "nameKey":"UnitStat_DodgePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Dodge",
      "detailedName":"Dodge Percent Additive"
    },
    "20":{
      "statId":20,
      "nameKey":"UnitStat_DeflectionPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Deflection",
      "detailedName":"Deflection Percent Additive"
    },
    "21":{
      "statId":21,
      "nameKey":"UnitStat_AttackCriticalPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Physical Critical Chance",
      "detailedName":"Physical Critical Percent Additive"
    },
    "22":{
      "statId":22,
      "nameKey":"UnitStat_AbilityCriticalPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Special Critical Chance",
      "detailedName":"Special Critical Percent Additive"
    },
    "23":{
      "statId":23,
      "nameKey":"UnitStat_ArmorPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Armor",
      "detailedName":"Armor Percent Additive"
    },
    "24":{
      "statId":24,
      "nameKey":"UnitStat_SuppressionPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Resistance",
      "detailedName":"Resistance Percent Additive"
    },
    "25":{
      "statId":25,
      "nameKey":"UnitStat_ArmorPenetrationPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Armor Penetration",
      "detailedName":"Armor Penetration Percent Additive"
    },
    "26":{
      "statId":26,
      "nameKey":"UnitStat_SuppressionPenetrationPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Resistance Penetration",
      "detailedName":"Resistance Penetration Percent Additive"
    },
    "27":{
      "statId":27,
      "nameKey":"UnitStat_HealthSteal",
      "descKey":"UnitStatDescription_HealthSteal",
      "isDecimal":true,
      "name":"Health Steal",
      "detailedName":"Health Steal"
    },
    "28":{
      "statId":28,
      "nameKey":"UnitStat_MaxShield",
      "descKey":"UnitStatDescription_MaxShield",
      "isDecimal":false,
      "name":"Protection",
      "detailedName":"Max Protection"
    },
    "29":{
      "statId":29,
      "nameKey":"UnitStat_ShieldPenetration",
      "descKey":"",
      "isDecimal":true,
      "name":"Protection Ignore",
      "detailedName":"Protection Ignore"
    },
    "30":{
      "statId":30,
      "nameKey":"UnitStat_HealthRegen",
      "descKey":"",
      "isDecimal":true,
      "name":"Health Regeneration",
      "detailedName":"Health Regen"
    },
    "31":{
      "statId":31,
      "nameKey":"UnitStat_AttackDamagePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Physical Damage",
      "detailedName":"Physical Damage Percent Additive"
    },
    "32":{
      "statId":32,
      "nameKey":"UnitStat_AbilityPowerPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Special Damage",
      "detailedName":"Special Damage Percent Additive"
    },
    "33":{
      "statId":33,
      "nameKey":"UnitStat_DodgeNegatePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Physical Accuracy",
      "detailedName":"Dodge Negate Percent Additive"
    },
    "34":{
      "statId":34,
      "nameKey":"UnitStat_DeflectionNegatePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Special Accuracy",
      "detailedName":"Deflection Negate Percent Additive"
    },
    "35":{
      "statId":35,
      "nameKey":"UnitStat_AttackCriticalNegatePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Physical Critical Avoidance",
      "detailedName":"Physical Critical Negate Percent Additive"
    },
    "36":{
      "statId":36,
      "nameKey":"UnitStat_AbilityCriticalNegatePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Special Critical Avoidance",
      "detailedName":"Special Critical Negate Percent Additive"
    },
    "37":{
      "statId":37,
      "nameKey":"UnitStat_DodgeNegateRating",
      "descKey":"UnitStatDescription_DodgeNegateRating",
      "isDecimal":false,
      "name":"Physical Accuracy",
      "detailedName":"Dodge Negate Rating"
    },
    "38":{
      "statId":38,
      "nameKey":"UnitStat_DeflectionNegateRating",
      "descKey":"UnitStatDescription_DeflectionNegateRating",
      "isDecimal":false,
      "name":"Special Accuracy",
      "detailedName":"Deflection Negate Rating"
    },
    "39":{
      "statId":39,
      "nameKey":"UnitStat_AttackCriticalNegateRating",
      "descKey":"UnitStatDescription_AttackCriticalNegateRating",
      "isDecimal":false,
      "name":"Physical Critical Avoidance",
      "detailedName":"Physical Critical Negate Rating"
    },
    "40":{
      "statId":40,
      "nameKey":"UnitStat_AbilityCriticalNegateRating",
      "descKey":"UnitStatDescription_AbilityCriticalNegateRating",
      "isDecimal":false,
      "name":"Special Critical Avoidance",
      "detailedName":"Special Critical Negate Rating"
    },
    "41":{
      "statId":41,
      "nameKey":"UnitStat_Offense",
      "descKey":"UnitStatDescription_Offense",
      "isDecimal":false,
      "name":"Offense",
      "detailedName":"Offense"
    },
    "42":{
      "statId":42,
      "nameKey":"UnitStat_Defense",
      "descKey":"UnitStatDescription_Defense",
      "isDecimal":false,"name":"Defense",
      "detailedName":"Defense"
    },
    "43":{
      "statId":43,
      "nameKey":"UnitStat_DefensePenetration",
      "descKey":"UnitStatDescription_DefensePenetration",
      "isDecimal":false,
      "name":"Defense Penetration",
      "detailedName":"Defense Penetration"
    },
    "44":{
      "statId":44,
      "nameKey":"UnitStat_EvasionRating",
      "descKey":"UnitStatDescription_EvasionRating",
      "isDecimal":false,
      "name":"Evasion",
      "detailedName":"Evasion Rating"
    },
    "45":{
      "statId":45,
      "nameKey":"UnitStat_CriticalRating",
      "descKey":"UnitStatDescription_CriticalRating",
      "isDecimal":false,
      "name":"Critical Chance",
      "detailedName":"Critical Rating"
    },
    "46":{
      "statId":46,
      "nameKey":"UnitStat_EvasionNegateRating",
      "descKey":"UnitStatDescription_EvasionNegateRating",
      "isDecimal":false,
      "name":"Accuracy",
      "detailedName":"Evasion Negate Rating"
    },
    "47":{
      "statId":47,
      "nameKey":"UnitStat_CriticalNegateRating",
      "descKey":"UnitStatDescription_CriticalNegateRating",
      "isDecimal":false,
      "name":"Critical Avoidance",
      "detailedName":"Critical Negate Rating"
    },
    "48":{
      "statId":48,
      "nameKey":"UnitStat_OffensePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Offense",
      "detailedName":"Offense Percent Additive"
    },
    "49":{
      "statId":49,
      "nameKey":"UnitStat_DefensePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Defense",
      "detailedName":"Defense Percent Additive"
    },
    "50":{
      "statId":50,
      "nameKey":"UnitStat_DefensePenetrationPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Defense Penetration",
      "detailedName":"Defense Penetration Percent Additive"
    },
    "51":{
      "statId":51,
      "nameKey":"UnitStat_EvasionPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Evasion",
      "detailedName":"Evasion Percent Additive"
    },
    "52":{
      "statId":52,
      "nameKey":"UnitStat_EvasionNegatePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Accuracy",
      "detailedName":"Evasion Negate Percent Additive"
    },
    "53":{
      "statId":53,
      "nameKey":"UnitStat_CriticalChancePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Critical Chance",
      "detailedName":"Critical Chance Percent Additive"
    },
    "54":{
      "statId":54,
      "nameKey":"UnitStat_CriticalNegateChancePercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Critical Avoidance",
      "detailedName":"Critical Negate Chance Percent Additive"
    },
    "55":{
      "statId":55,
      "nameKey":"UnitStat_MaxHealthPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Health",
      "detailedName":"Max Health Percent Additive"
    },
    "56":{
      "statId":56,
      "nameKey":"UnitStat_MaxShieldPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Protection",
      "detailedName":"Max Protection Percent Additive"
    },
    "57":{
      "statId":57,
      "nameKey":"UnitStat_SpeedPercentAdditive",
      "descKey":"",
      "isDecimal":true,
      "name":"Speed",
      "detailedName":"Speed Percent Additive"},
    "58":{
      "statId":58,
      "nameKey":"UnitStat_CounterAttackRating",
      "descKey":"",
      "isDecimal":true,
      "name":"Counter Attack",
      "detailedName":"Counter Attack Rating"
    },
    "59":{
      "statId":59,
      "nameKey":"Combat_Buffs_TASK_NAME_2",
      "descKey":"",
      "isDecimal":true,
      "name":"Taunt",
      "detailedName":"Taunt"
    },
    "60":{
      "statId":60,
      "nameKey":"UnitStat_DefensePenetrationTargetPercentAdditive",
      "descKey":"UnitStatDescription_DefensePenetrationTargetPercentAdditive",
      "isDecimal":true,
      "name":"Defense Penetration",
      "detailedName":"Target Defense Penetration Percent Additive"
    },
    "61":{
      "statId":61,
      "nameKey":"UNIT_STAT_STAT_VIEW_MASTERY",
      "descKey":"",
      "isDecimal":true,
      "name":"Mastery",
      "detailedName":"Mastery"
    }
  }

export const BattleOutcome = {
  0: "BattleOutcome_DEFAULT",
  1: "WIN",
  2: "LOSS",
  3: "RETREAT",
  4: "DRAW",
  5: "CLIENTSTOPPED"
}

export const squadsPerZone = {
  3: {
      KYBER: {
        '4zone_phase01_conflict01_duel01': 5,
        '4zone_phase01_conflict02_duel01': 5,
        '4zone_phase02_conflict02_duel01': 5,
        '4zone_phase02_conflict01_duel01': 3
      },
      AURODIUM: {
        '4zone_phase01_conflict01_duel01': 4,
        '4zone_phase01_conflict02_duel01': 4,
        '4zone_phase02_conflict02_duel01': 5,
        '4zone_phase02_conflict01_duel01': 2
      },
      CHROMIUM: {
        '4zone_phase01_conflict01_duel01': 3,
        '4zone_phase01_conflict02_duel01': 3,
        '4zone_phase02_conflict02_duel01': 4,
        '4zone_phase02_conflict01_duel01': 2
      },
      BRONZIUM: {
        '4zone_phase01_conflict01_duel01': 2,
        '4zone_phase01_conflict02_duel01': 2,
        '4zone_phase02_conflict02_duel01': 3,
        '4zone_phase02_conflict01_duel01': 1
      },
      CARBONITE: {
        '4zone_phase01_conflict01_duel01': 1,
        '4zone_phase01_conflict02_duel01': 1,
        '4zone_phase02_conflict02_duel01': 1,
        '4zone_phase02_conflict01_duel01': 1
      }
  },
  5: {
      KYBER: {
        '4zone_phase01_conflict01_duel01': 4,
        '4zone_phase01_conflict02_duel01': 4,
        '4zone_phase02_conflict02_duel01': 3,
        '4zone_phase02_conflict01_duel01': 3
      },
      AURODIUM: {
        '4zone_phase01_conflict01_duel01': 3,
        '4zone_phase01_conflict02_duel01': 3,
        '4zone_phase02_conflict02_duel01': 3,
        '4zone_phase02_conflict01_duel01': 2
      },
      CHROMIUM: {
        '4zone_phase01_conflict01_duel01': 3,
        '4zone_phase01_conflict02_duel01': 2,
        '4zone_phase02_conflict02_duel01': 2,
        '4zone_phase02_conflict01_duel01': 2
      },
      BRONZIUM: {
        '4zone_phase01_conflict01_duel01': 2,
        '4zone_phase01_conflict02_duel01': 2,
        '4zone_phase02_conflict02_duel01': 1,
        '4zone_phase02_conflict01_duel01': 1
      },
      CARBONITE: {
        '4zone_phase01_conflict01_duel01': 1,
        '4zone_phase01_conflict02_duel01': 1,
        '4zone_phase02_conflict02_duel01': 1,
        '4zone_phase02_conflict01_duel01': 1
      }
  }
}

export const tagOptions = [
  {text: 'GAC (3v3)', value: 'gac3'},
  {text: 'GAC (5v5)', value: 'gac5'},
  {text: 'TW', value: 'tw'},
  {text: 'Raid', value: 'raid'}
]

export const zoneNames = {

  /* ============================
     Phase 1 Mustafar, Corellia, Coruscant
     ============================ */

  tb3_mixed_phase01_conflict02: 'Mustafar',
  tb3_mixed_phase01_conflict03: 'Corellia',
  tb3_mixed_phase01_conflict01: 'Coruscant',

  // Mustafar CMs
  tb3_mixed_phase01_conflict02_strike01: 'LV',
  tb3_mixed_phase01_conflict02_strike02: 'Bottom Right',
  tb3_mixed_phase01_conflict02_strike03: 'Bottom Left',
  tb3_mixed_phase01_conflict02_strike04: 'Top Middle',
  tb3_mixed_phase01_conflict02_strike05: 'Fleet',

  // Corellia CMs
  tb3_mixed_phase01_conflict03_strike01: 'Middle',
  tb3_mixed_phase01_conflict03_strike02: 'Aphra',
  tb3_mixed_phase01_conflict03_strike03: 'Jabba',
  tb3_mixed_phase01_conflict03_strike04: 'Fleet',

  // Coruscant CMs
  tb3_mixed_phase01_conflict01_strike01: 'Jedi',
  tb3_mixed_phase01_conflict01_strike02: 'Mace/Kit',
  tb3_mixed_phase01_conflict01_strike03: 'Middle',
  tb3_mixed_phase01_conflict01_strike04: 'Left',
  tb3_mixed_phase01_conflict01_strike05: 'Fleet',

  // Corellia SMs
  tb3_mixed_phase01_conflict03_covert01: 'Qi\'ra & Young Han',

  // Mustafar Ops
  tb3_mixed_phase01_conflict02_recon01: 'Mustafar Operation',
  // Corellia Ops
  tb3_mixed_phase01_conflict03_recon01: 'Corellia Operation',
  // Coruscant Ops
  tb3_mixed_phase01_conflict01_recon01: 'Coruscant Operation',


  /* ============================
     Phase 2 Geonosis, Felucia, Bracca
     ============================ */

  tb3_mixed_phase02_conflict02: 'Geonosis',
  tb3_mixed_phase02_conflict03: 'Felucia',
  tb3_mixed_phase02_conflict01: 'Bracca',

  // Geonosis CMs
  tb3_mixed_phase02_conflict02_strike01: 'Geos',
  tb3_mixed_phase02_conflict02_strike02: 'Top Right',
  tb3_mixed_phase02_conflict02_strike03: 'Bottom',
  tb3_mixed_phase02_conflict02_strike04: 'Left',
  tb3_mixed_phase02_conflict02_strike05: 'Fleet',

  // Felucia CMs
  tb3_mixed_phase02_conflict03_strike01: 'YLando',
  tb3_mixed_phase02_conflict03_strike02: 'Middle',
  tb3_mixed_phase02_conflict03_strike03: 'Hondo',
  tb3_mixed_phase02_conflict03_strike04: 'Fleet',
  tb3_mixed_phase02_conflict03_strike05: 'Jabba',

  // Bracca CMs
  tb3_mixed_phase02_conflict01_strike01: 'Jedi',
  tb3_mixed_phase02_conflict01_strike02: 'Right',
  tb3_mixed_phase02_conflict01_strike03: 'Left',
  tb3_mixed_phase02_conflict01_strike04: 'Fleet',

  // Bracca SMs
  tb3_mixed_phase02_conflict01_covert01: 'Zeffo unlock',

  // Geonosis Ops
  tb3_mixed_phase02_conflict02_recon01: 'Geonosis Operation',
  // Felucia Ops
  tb3_mixed_phase02_conflict03_recon01: 'Felucia Operation',
  // Bracca Ops
  tb3_mixed_phase02_conflict01_recon01: 'Bracca Operation',


  /* ============================
     Phase 3 Dathomir, Tatooine, Kashyyyk, Zeffo
     ============================ */

  tb3_mixed_phase03_conflict02: 'Dathomir',
  tb3_mixed_phase03_conflict03: 'Tatooine',
  tb3_mixed_phase03_conflict01: 'Kashyyyk',
  tb3_mixed_phase03_conflict01_bonus: 'Zeffo',

  // Dathomir CMs
  tb3_mixed_phase03_conflict02_strike01: 'Middle',
  tb3_mixed_phase03_conflict02_strike02: 'Aphra',
  tb3_mixed_phase03_conflict02_strike03: 'Right',
  tb3_mixed_phase03_conflict02_strike04: 'Empire',

  // Tatooine CMs
  tb3_mixed_phase03_conflict03_strike01: 'Fennec',
  tb3_mixed_phase03_conflict03_strike03: 'Top Left',
  tb3_mixed_phase03_conflict03_strike04: 'Jabba',
  tb3_mixed_phase03_conflict03_strike05: 'Fleet',

  // Kashyyyk CMs
  tb3_mixed_phase03_conflict01_strike01: 'Bottom Left',
  tb3_mixed_phase03_conflict01_strike02: 'Top Right',
  tb3_mixed_phase03_conflict01_strike03: 'Wookiees',
  tb3_mixed_phase03_conflict01_strike04: 'Fleet',

  // Zeffo CMs bonus
  tb3_mixed_phase03_conflict01_bonus_strike01: 'Middle',
  tb3_mixed_phase03_conflict01_bonus_strike02: 'UFUs',
  tb3_mixed_phase03_conflict01_bonus_strike03: 'JKCK',
  tb3_mixed_phase03_conflict01_bonus_strike04: 'Fleet',

  // Kashyyyk SMs
  tb3_mixed_phase03_conflict01_covert01: 'Saw',
  // Zeffo SMs bonus
  tb3_mixed_phase03_conflict01_bonus_covert01: 'Clones',
  // Dathomir SMs
  tb3_mixed_phase03_conflict02_covert01: 'Merrin',
  // Tatooine SMs
  tb3_mixed_phase03_conflict03_covert01: 'Reva unlock',
  tb3_mixed_phase03_conflict03_covert02: 'Mandalore unlock',

  // Dathomir Ops
  tb3_mixed_phase03_conflict02_recon01: 'Dathomir Operation',
  // Tatooine Ops
  tb3_mixed_phase03_conflict03_recon01: 'Tatooine Operation',
  // Kashyyyk Ops
  tb3_mixed_phase03_conflict01_recon01: 'Kashyyyk Operation',
  // Zeffo Ops bonus
  tb3_mixed_phase03_conflict01_bonus_recon01: 'Zeffo Operation',


  /* ============================
     Phase 4 Haven-class, Kessel, Lothal, Mandalore
     ============================ */

  tb3_mixed_phase04_conflict02: 'Haven-class Medical Station',
  tb3_mixed_phase04_conflict03: 'Kessel',
  tb3_mixed_phase04_conflict01: 'Lothal',
  tb3_mixed_phase04_conflict03_bonus: 'Mandalore',

  // Haven-class CMs
  tb3_mixed_phase04_conflict02_strike01: 'Top Right',
  tb3_mixed_phase04_conflict02_strike02: 'Bottom Middle',
  tb3_mixed_phase04_conflict02_strike03: 'Left',
  tb3_mixed_phase04_conflict02_strike04: 'Top Middle',

  // Kessel CMs
  tb3_mixed_phase04_conflict03_strike01: 'Jabba',
  tb3_mixed_phase04_conflict03_strike02: 'Top Right',
  tb3_mixed_phase04_conflict03_strike03: 'Top Left',
  tb3_mixed_phase04_conflict03_strike04: 'Fleet',

  // Lothal CMs
  tb3_mixed_phase04_conflict01_strike01: 'Top Right',
  tb3_mixed_phase04_conflict01_strike02: 'Bottom',
  tb3_mixed_phase04_conflict01_strike03: 'Phoenix',
  tb3_mixed_phase04_conflict01_strike04: 'Fleet',
  tb3_mixed_phase04_conflict01_specialmission: '<Hidden>',

  // Mandalore CMs bonus
  tb3_mixed_phase04_conflict03_bonus_strike01: 'DTMG',
  tb3_mixed_phase04_conflict03_bonus_strike02: 'Top Right',
  tb3_mixed_phase04_conflict03_bonus_strike03: 'BKM Mandos',
  tb3_mixed_phase04_conflict03_bonus_strike04: 'Fleet',

  // Haven-class SMs
  tb3_mixed_phase04_conflict02_covert01: 'Reva Inqs',
  // Kessel SMs
  tb3_mixed_phase04_conflict03_covert01: 'Qi\'ra & L3',

  // Haven-class Ops
  tb3_mixed_phase04_conflict02_recon01: 'Haven-class Medical Station Operation',
  // Kessel Ops
  tb3_mixed_phase04_conflict03_recon01: 'Kessel Operation',
  // Mandalore Ops bonus
  tb3_mixed_phase04_conflict03_bonus_recon01: 'Mandalore Operation',
  // Lothal Ops
  tb3_mixed_phase04_conflict01_recon01: 'Lothal Operation',


  /* ============================
     Phase 5 Malachor, Vandor, Ring of Kafrene
     ============================ */

  tb3_mixed_phase05_conflict02: 'Malachor',
  tb3_mixed_phase05_conflict03: 'Vandor',
  tb3_mixed_phase05_conflict01: 'Ring of Kafrene',

  // Malachor CMs
  tb3_mixed_phase05_conflict02_strike01: '5B/7S/8B',
  tb3_mixed_phase05_conflict02_strike02: 'Top Left',
  tb3_mixed_phase05_conflict02_strike03: 'Bottom Left',
  tb3_mixed_phase05_conflict02_strike04: 'Top Right',

  // Vandor CMs
  tb3_mixed_phase05_conflict03_strike01: 'Top Right',
  tb3_mixed_phase05_conflict03_strike02: 'Jabba',
  tb3_mixed_phase05_conflict03_strike03: 'Bottom Left',
  tb3_mixed_phase05_conflict03_strike04: 'Fleet',
  tb3_mixed_phase05_conflict03_specialmission: '<Hidden>',

  // Ring of Kafrene CMs
  tb3_mixed_phase05_conflict01_strike01: 'Cassian & K2',
  tb3_mixed_phase05_conflict01_strike02: 'Bottom',
  tb3_mixed_phase05_conflict01_strike03: 'Middle Left',
  tb3_mixed_phase05_conflict01_strike04: 'Top Left',
  tb3_mixed_phase05_conflict01_strike05: 'Fleet',

  // Vandor SMs
  tb3_mixed_phase05_conflict03_covert01: 'Young Han & Vandor Chewis',

  // Malachor Ops
  tb3_mixed_phase05_conflict02_recon01: 'Malachor Operation',
  // Vandor Ops
  tb3_mixed_phase05_conflict03_recon01: 'Vandor Operation',
  // Ring of Kafrene Ops
  tb3_mixed_phase05_conflict01_recon01: 'Ring of Kafrene Operation',


  /* ============================
     Phase 6 Death Star, Hoth, Scarif
     ============================ */

  tb3_mixed_phase06_conflict02: 'Death Star',
  tb3_mixed_phase06_conflict03: 'Hoth',
  tb3_mixed_phase06_conflict01: 'Scarif',

  // Death Star CMs
  tb3_mixed_phase06_conflict02_strike01: 'Darth Vader',
  tb3_mixed_phase06_conflict02_strike02: 'Bottom Right',
  tb3_mixed_phase06_conflict02_strike03: 'Bottom Left',
  tb3_mixed_phase06_conflict02_strike04: 'Iden',
  tb3_mixed_phase06_conflict02_strike05: 'Fleet',

  // Hoth CMs
  tb3_mixed_phase06_conflict03_strike01: 'Jabba',
  tb3_mixed_phase06_conflict03_strike02: 'Bottom Left',
  tb3_mixed_phase06_conflict03_strike03: 'Top Middle',
  tb3_mixed_phase06_conflict03_strike04: 'Aphra, BT-1, & 0-0-0',
  tb3_mixed_phase06_conflict03_strike05: 'Fleet',

  // Scarif CMs
  tb3_mixed_phase06_conflict01_strike01: 'Baze, Chirrut, & SRP',
  tb3_mixed_phase06_conflict01_strike02: 'Middle Right',
  tb3_mixed_phase06_conflict01_strike03: 'Bottom Left',
  tb3_mixed_phase06_conflict01_strike04: 'Fleet',
  tb3_mixed_phase06_conflict01_specialmission: 'Cassian, K2, & Pao',

  // Death Star Ops
  tb3_mixed_phase06_conflict02_recon01: 'Death Star Operation',
  // Hoth Ops
  tb3_mixed_phase06_conflict03_recon01: 'Hoth Operation',
  // Scarif Ops
  tb3_mixed_phase06_conflict01_recon01: 'Scarif Operation'
}

export const zoneTypeNames = {

  /* ============================
     Phase 1 Mustafar, Corellia, Coruscant
     ============================ */

  tb3_mixed_phase01_conflict02: 'DS 1',
  tb3_mixed_phase01_conflict03: 'Mix 1',
  tb3_mixed_phase01_conflict01: 'LS 1',


  /* ============================
     Phase 2 Geonosis, Felucia, Bracca
     ============================ */

  tb3_mixed_phase02_conflict02: 'DS 2',
  tb3_mixed_phase02_conflict03: 'Mix 2',
  tb3_mixed_phase02_conflict01: 'LS 2',


  /* ============================
     Phase 3 Dathomir, Tatooine, Kashyyyk, Zeffo
     ============================ */

  tb3_mixed_phase03_conflict02: 'DS 3',
  tb3_mixed_phase03_conflict03: 'Mix 3',
  tb3_mixed_phase03_conflict01: 'LS 3',
  tb3_mixed_phase03_conflict01_bonus: 'Bonus 3',


  /* ============================
     Phase 4 Haven-class, Kessel, Lothal, Mandalore
     ============================ */

  tb3_mixed_phase04_conflict02: 'DS 4',
  tb3_mixed_phase04_conflict03: 'Mix 4',
  tb3_mixed_phase04_conflict01: 'LS 4',
  tb3_mixed_phase04_conflict03_bonus: 'Bonus 4',


  /* ============================
     Phase 5 Malachor, Vandor, Ring of Kafrene
     ============================ */

  tb3_mixed_phase05_conflict02: 'DS 5',
  tb3_mixed_phase05_conflict03: 'Mix 5',
  tb3_mixed_phase05_conflict01: 'LS 5',


  /* ============================
     Phase 6 Death Star, Hoth, Scarif
     ============================ */

  tb3_mixed_phase06_conflict02: 'DS 6',
  tb3_mixed_phase06_conflict03: 'Mix 6',
  tb3_mixed_phase06_conflict01: 'LS 6'
}
